import * as preact from 'preact'
const { h, Component } = preact
import * as styles from './style.css'
import { Video as VideoProps } from '../../types'
import { HTML5Video } from '../../../lib/html5video'
import { getVideo } from '../../../lib/getVideo'
import PureComponent from '../../../lib/preact-pure-component'
import classNames from 'classnames'
interface Props {
  video?: VideoProps[]
  active: boolean
  style?: string
  preload: boolean
  pauseUntilVisible?: boolean
  fadeClasses: string
}

export class Video extends PureComponent<Props & VideoProps, {}> {
  shouldPlay = () => {
    const { active, preload, pauseUntilVisible } = this.props
    if (active) {
      return true
    }
    if (preload && !pauseUntilVisible) {
      return true
    }
    return false
  }
  render() {
    const video = getVideo(this.props.video)
    if (video) {
      const { style } = this.props
      const { poster, sources, size } = video
      const elementClasses = classNames(this.props.fadeClasses, styles.videoElement)
      return (
        <div className={styles.video}>
          <HTML5Video
            playing={this.shouldPlay()}
            className={elementClasses}
            sources={sources}
            size={size}
            poster={poster}
          />
        </div>
      )
    }
    return <div />
  }
}
